import { render, staticRenderFns } from "./Umkm.vue?vue&type=template&id=1b427596&"
import script from "./Umkm.vue?vue&type=script&lang=js&"
export * from "./Umkm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports